module.exports = __webpack_public_path__ + "img/NETWORK NAME BLACK.a7e88f8e.svg";